// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__11Ds3","resendInfoText":"OnGoingPaymentBox_resendInfoText__16yUb"};